import { db, type ConsoleEventRecord } from './codexDB';

const KEEP_PER_PROJECT = 500; // 세션 영속 상한 — 오래된 이벤트부터 정리(타임라인 무한 성장 방지)

export async function appendConsoleEvent(record: ConsoleEventRecord): Promise<void> {
  await db.consoleEvents.add(record);
  const count = await db.consoleEvents.where('projectId').equals(record.projectId).count();
  if (count > KEEP_PER_PROJECT) {
    const overflow = await db.consoleEvents
      .where('projectId')
      .equals(record.projectId)
      .sortBy('seq')
      .then((rows) => rows.slice(0, count - KEEP_PER_PROJECT));
    await db.consoleEvents.bulkDelete(overflow.map((r) => r.seq!).filter((s) => s !== undefined));
  }
}

/** 프로젝트 세션 복원 — seq 순(시간순), 최근 limit개. */
export async function listConsoleEvents(projectId: string, limit = 200): Promise<ConsoleEventRecord[]> {
  const rows = await db.consoleEvents.where('projectId').equals(projectId).sortBy('seq');
  return rows.slice(-limit);
}

export async function clearConsoleEvents(projectId: string): Promise<void> {
  await db.consoleEvents.where('projectId').equals(projectId).delete();
}
